(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apple-product-viewer"] && !Shopify.designMode) return;
  try {
    
  const clearSecondaryTabs = (viewer) => {
    viewer?.querySelectorAll('[data-apv-secondary-tab]').forEach((groupTab) => {
      groupTab.classList.remove('is-active');
      groupTab.setAttribute('aria-pressed', 'false');
    });
  };

  const activateControlItem = (viewer, item) => {
    const opener = item?.querySelector('[data-apv-open]');
    const targetPanel = opener?.dataset.apvOpen;

    if (!viewer || !item || !targetPanel) {
      return;
    }

    viewer.querySelectorAll('.control-item').forEach((controlItem) => {
      const isCurrent = controlItem === item;
      controlItem.classList.toggle('is-current', isCurrent);
      controlItem.classList.toggle('is-open', isCurrent);
      controlItem.querySelector('.control-item-open')?.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
      controlItem.querySelector('.control-item-content')?.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
    });

    viewer.querySelectorAll('[data-apv-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.apvPanel === targetPanel);
    });

    clearSecondaryTabs(viewer);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-apv-open]');

    if (opener) {
      const item = opener.closest('.control-item');
      const viewer = opener.closest('apple-product-viewer');

      event.preventDefault();
      activateControlItem(viewer, item);
    }

    const paddle = event.target.closest('[data-apv-prev], [data-apv-next]');

    if (paddle) {
      const viewer = paddle.closest('apple-product-viewer');
      const items = Array.from(viewer?.querySelectorAll('.control-item') || []);
      const currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-current')));
      const direction = paddle.hasAttribute('data-apv-prev') ? -1 : 1;
      const nextIndex = (currentIndex + direction + items.length) % items.length;

      event.preventDefault();
      activateControlItem(viewer, items[nextIndex]);
    }

    const tab = event.target.closest('[data-apv-secondary-tab][data-apv-panel-target]');

    if (!tab) {
      return;
    }

    const viewer = tab.closest('apple-product-viewer');
    const tabGroup = tab.closest('[data-apv-secondary-tabs]');

    if (!viewer || !tabGroup) {
      return;
    }

    event.preventDefault();

    tabGroup.querySelectorAll('[data-apv-secondary-tab]').forEach((groupTab) => {
      const isActive = groupTab === tab;
      groupTab.classList.toggle('is-active', isActive);
      groupTab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const targetPanel = tab.dataset.apvPanelTarget;

    viewer.querySelectorAll('[data-apv-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.apvPanel === targetPanel);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-tablets"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tablet-comparison')) {
    customElements.define(
      'tablet-comparison',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.resizeObserver?.disconnect();
          this.controller = new AbortController();
          this.scrollArea = this.querySelector('.tablet-comparison__scroll');
          this.scrollbar = this.querySelector('.tablet-comparison__scrollbar');
          this.range = this.querySelector('.tablet-comparison__range');
          const options = { signal: this.controller.signal };
          this.range.addEventListener(
            'input',
            () => {
              const maximum = this.scrollArea.scrollWidth - this.scrollArea.clientWidth;
              const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
              this.scrollArea.scrollLeft = (direction * maximum * Number(this.range.value)) / 1000;
            },
            options
          );
          this.scrollArea.addEventListener('scroll', () => this.syncScrollbar(), options);
          this.resizeObserver = new ResizeObserver(() => this.syncScrollbar());
          this.resizeObserver.observe(this.scrollArea);
          this.resizeObserver.observe(this.querySelector('table'));
          this.classList.add('has-custom-scrollbar');
          this.syncScrollbar();
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const column = Array.from(this.querySelectorAll('[data-comparison-block]')).find(
                (element) => element.dataset.comparisonBlock === event.detail.blockId
              );
              if (!column) return;
              const scroll = this.querySelector('.tablet-comparison__scroll');
              const label = this.querySelector('.tablet-comparison__label');
              const rtl = getComputedStyle(this).direction === 'rtl';
              const bounds = scroll.getBoundingClientRect();
              const cell = column.getBoundingClientRect();
              const offset = rtl
                ? cell.right - bounds.right + label.offsetWidth
                : cell.left - bounds.left - label.offsetWidth;
              scroll.scrollBy({ left: offset, behavior: 'instant' });
            },
            { signal: this.controller.signal }
          );
        }
        syncScrollbar() {
          const width = this.scrollArea.clientWidth;
          const total = this.scrollArea.scrollWidth;
          const maximum = Math.max(0, total - width);
          this.scrollbar.hidden = maximum <= 1;
          this.range.disabled = maximum <= 1;
          this.range.value =
            maximum > 0 ? Math.min(1000, Math.max(0, (Math.abs(this.scrollArea.scrollLeft) / maximum) * 1000)) : 0;
          const thumbWidth = total > 0 ? Math.max(24, (this.scrollbar.clientWidth * width) / total) : 0;
          this.range.style.setProperty('--comparison-thumb-width', `${thumbWidth}px`);
        }
        disconnectedCallback() {
          this.controller?.abort();
          this.resizeObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_new"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-countdown-discount')) {
    customElements.define('product-countdown-discount', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.root = this.querySelector('[data-countdown-discount]');
        if (!this.root) return;
        const end = Date.parse(this.root.dataset.endTime);
        const timer = this.querySelector('[data-timer]');
        timer.hidden = !Number.isFinite(end);
        if (Number.isFinite(end)) {
          const update = () => {
            const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
            const values = { d: Math.floor(seconds / 86400), h: Math.floor(seconds / 3600) % 24, m: Math.floor(seconds / 60) % 60, s: seconds % 60 };
            Object.entries(values).forEach(([unit, value]) => {
              timer.querySelector('.' + unit).textContent = String(value).padStart(2, '0');
            });
            if (seconds === 0) clearInterval(this.interval);
          };
          update();
          if (end > Date.now()) this.interval = setInterval(update, 1000);
        }
        this.copyButton = this.querySelector('[data-copy]');
        this.copyHandler = async () => {
          const button = this.copyButton;
          const code = button.dataset.copyText;
          let copied = false;
          try {
            await navigator.clipboard.writeText(code);
            copied = true;
          } catch {
            const field = document.createElement('textarea');
            field.value = code;
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            try { copied = document.execCommand('copy'); } catch {}
            field.remove();
            button.focus();
          }
          if (!this.isConnected) return;
          if (copied) {
            button.textContent = button.dataset.copiedLabel;
            clearTimeout(this.resetTimeout);
            this.resetTimeout = setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 2000);
          } else {
            button.textContent = code;
          }
        };
        this.copyButton?.addEventListener('click', this.copyHandler);
      }
      cleanup() {
        clearInterval(this.interval);
        clearTimeout(this.resetTimeout);
        this.copyButton?.removeEventListener('click', this.copyHandler);
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-benefits-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-benefits-bar')) {
    customElements.define('service-benefits-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.controller && !this.controller.signal.aborted) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.setupSlider(options);
        this.pairs = [...this.querySelectorAll('[popovertarget]')].map(trigger => ({
          trigger,
          panel: this.querySelector('#' + CSS.escape(trigger.getAttribute('popovertarget')))
        })).filter(pair => pair.panel);
        this.keyboard = false;
        document.addEventListener('keydown', event => {
          this.keyboard = true;
          if (event.key === 'Escape') this.closeAll();
        }, options);
        document.addEventListener('pointerdown', () => { this.keyboard = false; }, options);
        this.pairs.forEach(pair => {
          if (!pair.panel || !pair.panel.showPopover) return;
          const open = () => {
            clearTimeout(this.closeTimer);
            this.pairs.forEach(other => {
              if (other !== pair && other.panel.matches(':popover-open')) other.panel.hidePopover();
            });
            if (!pair.panel.matches(':popover-open')) pair.panel.showPopover();
            this.position(pair);
          };
          const leave = () => {
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(() => {
              if (!pair.trigger.matches(':hover') && !pair.panel.matches(':hover') &&
                  !pair.panel.contains(document.activeElement) && document.activeElement !== pair.trigger &&
                  pair.panel.matches(':popover-open')) pair.panel.hidePopover();
            }, 180);
          };
          pair.trigger.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') open();
          }, options);
          pair.trigger.addEventListener('pointerleave', leave, options);
          pair.trigger.addEventListener('focus', () => { if (this.keyboard) open(); }, options);
          pair.trigger.addEventListener('blur', leave, options);
          pair.panel.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
          pair.panel.addEventListener('pointerleave', leave, options);
          pair.panel.addEventListener('focusout', leave, options);
          pair.panel.addEventListener('toggle', () => {
            const expanded = pair.panel.matches(':popover-open');
            pair.trigger.setAttribute('aria-expanded', String(expanded));
            if (expanded) this.position(pair);
          }, options);
        });
        window.addEventListener('resize', () => this.closeAll(), options);
        document.addEventListener('scroll', event => {
          if (!this.pairs.some(pair => pair.panel.contains(event.target))) this.closeAll();
        }, { ...options, capture: true, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const pair = this.pairs.find(pair => event.target.contains(pair.trigger));
          if (pair && pair.panel.showPopover) {
            pair.panel.showPopover();
            this.position(pair);
          }
        }, options);
        this.addEventListener('shopify:block:deselect', () => this.closeAll(), options);
      }
      setupSlider(options) {
        this.track = this.querySelector('.service-benefits__list');
        this.controls = this.querySelector('.service-benefits__controls');
        if (!this.track || !this.controls) return;
        this.previous = this.controls.querySelector('[name="previous"]');
        this.next = this.controls.querySelector('[name="next"]');
        if (!this.previous || !this.next) return;
        this.mobileSliderQuery = window.matchMedia('(max-width: 749px)');
        this.mobileSliderQuery.addEventListener('change', () => this.scheduleSliderUpdate(), options);
        this.previous.addEventListener('click', () => this.moveSlide(-1), options);
        this.next.addEventListener('click', () => this.moveSlide(1), options);
        this.track.addEventListener('scroll', () => this.scheduleSliderUpdate(), { ...options, passive: true });
        this.sliderObserver = new ResizeObserver(() => this.scheduleSliderUpdate());
        this.sliderObserver.observe(this.track);
        this.updateSlider();
      }
      scheduleSliderUpdate() {
        if (this.sliderFrame || !this.isConnected || this.controller.signal.aborted) return;
        this.sliderFrame = requestAnimationFrame(() => {
          this.sliderFrame = 0;
          if (this.isConnected && !this.controller.signal.aborted) this.updateSlider();
        });
      }
      updateSlider() {
        if (!this.mobileSliderQuery.matches) {
          if (!this.controls.hidden) this.controls.hidden = true;
          return;
        }
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        const hidden = maximum <= 1;
        const previousDisabled = position <= 1;
        const nextDisabled = position >= maximum - 1;
        if (this.controls.hidden !== hidden) this.controls.hidden = hidden;
        if (this.previous.disabled !== previousDisabled) this.previous.disabled = previousDisabled;
        if (this.next.disabled !== nextDisabled) this.next.disabled = nextDisabled;
      }
      moveSlide(direction) {
        this.closeAll();
        const width = this.track.clientWidth;
        if (!width) return;
        const maximum = this.track.scrollWidth - width;
        const current = Math.round(Math.abs(this.track.scrollLeft) / width);
        const target = Math.max(0, Math.min((current + direction) * width, maximum));
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({
          left: rtl ? -target : target,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      position({ trigger, panel }) {
        const rect = trigger.getBoundingClientRect();
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        const left = Math.max(12, Math.min(rect.left + (rect.width - width) / 2, window.innerWidth - width - 12));
        let top = rect.bottom + 8;
        if (top + height > window.innerHeight - 12 && rect.top > height + 20) top = rect.top - height - 8;
        top = Math.max(12, Math.min(top, window.innerHeight - height - 12));
        panel.style.left = left + 'px';
        panel.style.top = top + 'px';
      }
      closeAll() {
        clearTimeout(this.closeTimer);
        this.pairs?.forEach(({ panel }) => {
          if (panel.matches(':popover-open')) panel.hidePopover();
        });
      }
      disconnectedCallback() {
        this.closeAll();
        this.controller?.abort();
        this.sliderObserver?.disconnect();
        cancelAnimationFrame(this.sliderFrame);
        this.sliderFrame = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('top-features')) {
    customElements.define('top-features', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.items = Array.from(this.querySelectorAll('.top-features__item'));
        this.dots = Array.from(this.querySelectorAll('.top-features__dot'));
        this.track = this.querySelector('.top-features__track');
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.active = 0;
        this.items.forEach((item, index) => {
          item.querySelector('button').addEventListener('click', () => this.select(index), options);
        });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.items.findIndex((item) => item.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.select(index, false);
        }, options);
        this.track.addEventListener('scroll', () => {
          if (this.desktop.matches) return;
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const left = this.track.getBoundingClientRect().left;
            let closest = 0;
            this.items.forEach((item, index) => {
              if (Math.abs(item.getBoundingClientRect().left - left) < Math.abs(this.items[closest].getBoundingClientRect().left - left)) closest = index;
            });
            this.update(closest);
          });
        }, options);
        this.desktop.addEventListener('change', () => this.select(this.active, false), options);
        this.resize = new ResizeObserver(() => {
          this.style.setProperty('--feature-media-height', `${Math.max(0, this.track.clientWidth / 2 - 20)}px`);
          if (!this.desktop.matches) this.scrollToItem(this.active, false);
        });
        this.resize.observe(this.track);
        this.classList.add('is-ready');
        this.update(0);
      }
      update(index) {
        this.active = index;
        this.items.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          item.querySelector('button').setAttribute('aria-expanded', String(!this.desktop.matches || i === index));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
      scrollToItem(index, smooth) {
        if (!this.items[index]) return;
        const distance = this.items[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({ left: distance, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      }
      select(index, smooth = true) {
        this.update(index);
        if (!this.desktop.matches) this.scrollToItem(index, smooth);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
